import React from "react"

const Section = ({ children }) => (
  <section className="section">{children}</section>
)

export default Section
